import { render, staticRenderFns } from "./VideoBottomBar.vue?vue&type=template&id=038ad1ec&scoped=true"
import script from "./VideoBottomBar.vue?vue&type=script&lang=js"
export * from "./VideoBottomBar.vue?vue&type=script&lang=js"
import style0 from "./VideoBottomBar.vue?vue&type=style&index=0&id=038ad1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ad1ec",
  null
  
)

export default component.exports